$( document ).ready(function() {
  $('.izimodal').iziModal({
    padding: 40,
    width: 680,
    headerColor: '#ccc',
    navigateArrows: true,
    group: 'products',
    loop: true,
    arrowKeys: true,
    focusInput: false,
    borderBottom: false,
    icon: 'fa-wine-glass-alt',
    closeButton: true
  });
});
